// extracted by mini-css-extract-plugin
export default {"link":"oC-z","disabled":"pC-z"};